(function () {
  'use strict';

  var styleId = 'adelina-revoq-theme';
  var selector = '[data-widerruf-popup-source]';

  function setTriggerColors(button, inverted) {
    if (!button) {
      return;
    }

    button.style.setProperty('background', inverted ? '#1c1b1b' : '#ffffff', 'important');
    button.style.setProperty('background-color', inverted ? '#1c1b1b' : '#ffffff', 'important');
    button.style.setProperty('color', inverted ? '#ffffff' : '#1c1b1b', 'important');
    button.style.setProperty('-webkit-text-fill-color', inverted ? '#ffffff' : '#1c1b1b', 'important');
  }

  function syncTriggerVisibility(button) {
    var cartDrawer = document.getElementById('sidebar-cart');
    var cartIsOpen = cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false';

    button.style.setProperty('opacity', cartIsOpen ? '0' : '1', 'important');
    button.style.setProperty('pointer-events', cartIsOpen ? 'none' : 'auto', 'important');
    button.style.setProperty('transform', cartIsOpen ? 'translateY(12px)' : 'translateY(0)', 'important');
  }

  function applyTheme(host) {
    if (!host || !host.shadowRoot) {
      return;
    }

    if (!host.shadowRoot.getElementById(styleId)) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        '.widerruf-trigger-button {',
        '  --widerruf-trigger-bg: #ffffff !important;',
        '  --widerruf-trigger-bg-hover: #1c1b1b !important;',
        '  --widerruf-trigger-text: #1c1b1b !important;',
        '  border: 1px solid #1c1b1b !important;',
        '  font-family: inherit !important;',
        '  font-weight: 400 !important;',
        '  letter-spacing: 0.18em !important;',
        '  text-transform: uppercase !important;',
        '  transition: background-color 0.25s ease, color 0.25s ease, opacity 0.25s ease, transform 0.25s ease !important;',
        '}',
        '@media (max-width: 640px) {',
        '  .widerruf-trigger-button {',
        '    letter-spacing: 0.14em !important;',
        '  }',
        '}'
      ].join('\n');

      host.shadowRoot.appendChild(style);
    }

    var button = host.shadowRoot.querySelector('.widerruf-trigger-button');
    if (!button) {
      return;
    }

    syncTriggerVisibility(button);

    if (button.dataset.adelinaHoverBound === 'true') {
      return;
    }

    button.dataset.adelinaHoverBound = 'true';
    setTriggerColors(button, false);
    button.addEventListener('mouseenter', function () {
      setTriggerColors(button, true);
    });
    button.addEventListener('mouseleave', function () {
      setTriggerColors(button, false);
    });
    button.addEventListener('focus', function () {
      setTriggerColors(button, true);
    });
    button.addEventListener('blur', function () {
      setTriggerColors(button, false);
    });

  }

  function applyAll() {
    document.querySelectorAll(selector).forEach(applyTheme);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  new MutationObserver(applyAll).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true,
    subtree: true
  });
})();
